<div id="menuVorauswahlToolbarContainer">
  <speiseplan-kalender
    *ngIf="mandant && apiZeitraum"
    [mandant]="mandant"
    [kunde]="kunde"
    [apiZeitraum]="apiZeitraum"
    (zeitraum_update)="menuVorauswahlLaden($event)"
  ></speiseplan-kalender>
</div>
